import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * Per-queue job counts returned by `GET /admin/bullmq/counts`.
 * `error` is present when the server failed to fetch counts for that queue —
 * the other fields are then zero but still rendered.
 */
export interface QueueCounts {
  active: number
  waiting: number
  completed: number
  failed: number
  delayed: number
  error?: string
}

export interface BullmqCountsResponse {
  queues: Record<string, QueueCounts>
  fetchedAt: string
}

export const bullmqCountsQueryKey = ['admin', 'bullmq', 'counts'] as const

/**
 * Admin-only live feed of BullMQ queue stats. Used by the admin
 * SystemHealthPage to replace the hardcoded queue panel.
 *
 * Refetches every 10 seconds so the page "feels live" without hammering
 * Redis; per-queue failures still render as zeros with an `error` flag.
 */
export function useBullmqCounts() {
  return useQuery({
    queryKey: bullmqCountsQueryKey,
    queryFn: () => api.get<BullmqCountsResponse>('/admin/bullmq/counts'),
    refetchInterval: 10_000,
    staleTime: 5_000,
  })
}
